import { memo } from 'react';

import { ChatIcon } from 'basic-components/icons';

import './Header.scss';

const Header = () => (
  <div className="ng-python-editor__chat__content__header">
    <div className="ng-python-editor__chat__content__header__icon">
      <ChatIcon/>
    </div>
    <div className="ng-python-editor__chat__content__header__text">
      Python Assistant
    </div>
  </div>
)

export default memo(Header);
